import React from 'react'
import { ButtonBase, Box } from '@mui/material'
import ColorizeIcon from '@mui/icons-material/Colorize';

function ColorPickerIcon({onClick, customStyles, customIconStyles}) {

    const buttonBaseStyles = {
        borderRadius: '50%',
        width: '25px',
        height: '25px',
        backgroundColor: '#0475DD',
        boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
        position: 'relative',
    }

    const circleIconStyles = {
        fontSize: '40px', 
        // fill: '#0475DD', 
        fill: 'white'
        // position: 'absolute',
    }

    const iconBackground = {
        backgroundColor: '#0475DD',
        borderRadius: '50%',
        border: '3px solid black',
        width: '50px',
        height: '50px',

        // center the icon (child) on top of the white circle background
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    
    }
    return (
        // Outer box to center the button
        <Box sx={{display: 'flex', justifyContent: 'center', ...customStyles}}>
        <Box sx={{...iconBackground, ...customIconStyles}}>
            <ColorizeIcon sx={circleIconStyles}/>
        </Box>
        </Box>
    )
}

export default ColorPickerIcon